import { AssetGroup } from '../types/asset-group.interface';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { assetDefinition } from './asset.definition';

export const assetGroupDefinition: EntityDefinition<AssetGroup> = {
  entityType: 'AssetGroup',
  i18nBase: 'entities.assetGroup',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.assetGroup.fields.name',
        sortable: true,
        filterable: true,
        class: 'w-full min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [{ field: 'name', labelKey: 'entities.assetGroup.fields.name', required: true, type: 'text', minLength: 3, maxLength: 50 }],
  childRelation: {
    type: 'Asset',
    parentIdField: 'id',
    childParentIdField: 'assetGroupId',
    displayName: 'Assets',
  },
  childDefinition: assetDefinition,
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: AssetGroup) => !entity.hasAsset,
      errorMessageKey: 'entities.assetGroup.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: AssetGroup, store) => {
        if (!store) return true;
        const entities = store.getData<AssetGroup>('AssetGroup')();
        return !entities.some(g => g.name.toLowerCase().trim() === entity.name.toLowerCase().trim());
      },
      errorMessageKey: 'entities.assetGroup.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: AssetGroup, store) => {
        if (!store) return true;
        const entities = store.getData<AssetGroup>('AssetGroup')();
        return !entities.some(g => g.name.toLowerCase().trim() === entity.name.toLowerCase().trim() && g.id !== entity.id);
      },
      errorMessageKey: 'entities.assetGroup.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
      label: {
        addKey: 'entities.asset.messages.addButton',
      },
    },
    child: {
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.assetGroup.messages.createTitle',
      edit: () => 'entities.assetGroup.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.assetGroup.messages.addButton',
      create: () => 'entities.assetGroup.messages.addButton',
      edit: () => 'entities.assetGroup.messages.editTitleWithName',
      delete: () => 'entities.assetGroup.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.assetGroup.messages.deleteConfirm',
  },
  enableFiltering: true,
};
